import uniqid from 'uniqid';
import { REMOVE_TOAST, ADD_TOAST } from '../constants/action-types';

export const addToast = toastProps => {
  const id = uniqid();
  return {
    type: ADD_TOAST,
    toastProps,
    id,
  };
};

export const removeToast = id => ({
  type: REMOVE_TOAST,
  id,
});
